import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SpecraBadge, SpecraButton, SpecraEyebrow } from '@mono/ui-components/ensigns';
import { SpecraPageHeader } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTenantAreas } from '../../../../lib/access/useTenantAreas';
import { PricingSheetUploadDialog } from '../../../Delivery/Registries/PricingSheetUploadDialog';
import { useCanUploadPricingSheet } from '../../../Delivery/Registries/usePricingSheetUploadGate';
import { plural } from './model';
export function AnchorHeader({ dossier, onMap }) {
    const { anchor, counts } = dossier;
    const canMap = useTenantAreas().registries;
    const canUpload = useCanUploadPricingSheet();
    const [uploadOpen, setUploadOpen] = useState(false);
    const navigate = useNavigate();
    if (!anchor || !counts) return null;
    const crosswalk = anchor.crosswalkSources.join(' and ');
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(SpecraPageHeader, {
                titleSize: "home",
                eyebrow: /*#__PURE__*/ _jsx(SpecraEyebrow, {
                    children: "Labor category · occupational anchor"
                }),
                title: anchor.title,
                description: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        "SOC ",
                        anchor.socCode,
                        " ",
                        anchor.onetTitle,
                        crosswalk && ` · the same anchor ${crosswalk} crosswalk to`
                    ]
                }),
                meta: /*#__PURE__*/ _jsxs("div", {
                    className: "flex flex-wrap gap-2",
                    children: [
                        /*#__PURE__*/ _jsxs(SpecraBadge, {
                            variant: "outline",
                            children: [
                                plural(counts.entryVersions, 'version'),
                                " as written"
                            ]
                        }),
                        /*#__PURE__*/ _jsx(SpecraBadge, {
                            variant: "outline",
                            children: plural(counts.companies, 'company', 'companies')
                        }),
                        /*#__PURE__*/ _jsx(SpecraBadge, {
                            variant: "outline",
                            children: plural(counts.vehicles, 'vehicle')
                        }),
                        /*#__PURE__*/ _jsx(SpecraBadge, {
                            variant: "outline",
                            children: plural(counts.rateObservations, 'rate observation')
                        }),
                        /*#__PURE__*/ _jsxs(SpecraBadge, {
                            variant: "outline",
                            children: [
                                counts.visiblePeopleFilled,
                                ' ',
                                counts.visiblePeopleFilled === 1 ? 'person has' : 'people have',
                                " filled it"
                            ]
                        })
                    ]
                }),
                actions: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        canMap && /*#__PURE__*/ _jsx(SpecraButton, {
                            variant: "secondary",
                            onClick: onMap,
                            "data-testid": Testids.registryLcatAnchor.mapButton,
                            children: "Map a labor category"
                        }),
                        canUpload && /*#__PURE__*/ _jsx(SpecraButton, {
                            variant: "secondary",
                            onClick: ()=>setUploadOpen(true),
                            children: "Upload pricing sheet"
                        })
                    ]
                })
            }),
            canUpload && /*#__PURE__*/ _jsx(PricingSheetUploadDialog, {
                open: uploadOpen,
                onOpenChange: setUploadOpen,
                onStarted: ()=>navigate('/registries?tab=pricing-sheets')
            })
        ]
    });
}
